module.exports = __webpack_public_path__ + "static/media/zlp-v2-logo.d7564043.svg";